import { motion } from "framer-motion";

const ICON_URL =
"https://customer-assets.emergentagent.com/job_df08fd9d-8c90-48ff-b688-2c7fd585cbef/artifacts/5xj2rzv1_Screenshot%202026-06-11%20at%203.41.05%E2%80%AFPM.png";

const STATS = [
{ value: "65%", label: "Design time reclaimed" },
{ value: "10x", label: "Content velocity" },
{ value: "4 in 1", label: "Full product journey" }];


const scrollTo = (id) =>
document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

const Hero = () =>
<section
  id="hero"
  data-testid="hero-section"
  className="min-h-screen bg-[#E8380D] relative overflow-hidden flex items-center">
  
    {/* Brand icon — right side, blends into orange bg */}
    <div className="absolute right-0 top-0 bottom-0 w-[45%] hidden lg:flex items-center justify-end pointer-events-none select-none">
      <motion.img
      src={ICON_URL}
      alt=""
      aria-hidden="true"
      initial={{ opacity: 0, scale: 0.92 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 1.2, ease: "easeOut" }}
      className="w-full h-full object-cover object-center" />
    
      {/* Gradient to blend left edge */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#E8380D] via-[#E8380D]/70 to-transparent" />
    </div>

    {/* Hero content */}
    <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24 relative z-10 pt-32 pb-24 w-full">
      <div className="max-w-3xl">
        {/* Overline */}
        <motion.p
        data-testid="hero-overline"
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="font-mono text-xs md:text-sm uppercase tracking-[0.2em] font-bold text-black/60 mb-6">Intelligence Layer for Fashion & Lifestyle Retail


      </motion.p>

        {/* H1 */}
        <motion.h1
        data-testid="hero-heading"
        initial={{ opacity: 0, y: 48 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
        className="font-cabinet font-black uppercase text-[3.4rem] sm:text-7xl md:text-8xl lg:text-[7.5rem] tracking-tighter leading-[0.92] !mb-[32px] !mr-[0px] !text-[#000000]">
        
          IS AI DOING
          <br />
          ENOUGH
          <br />
          <span className="!text-[#000000]">FOR YOU?</span>
        </motion.h1>

        {/* Body */}
        <motion.p
        data-testid="hero-description"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.35 }}
        className="font-manrope text-base md:text-lg leading-relaxed font-medium text-black/75 max-w-xl mb-10">
        
          MERAI is the AI backbone of modern fashion retail; transforming how product is 
        <strong className="!shadow-2xs">designed</strong>, <strong>shown</strong>, and{" "}
          <strong> merchandised</strong> at scale. Built not to assist, but to transform.
        
      </motion.p>

        {/* CTAs */}
        <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.5 }}
        className="flex flex-wrap gap-4 mb-16">
        
          <button
          data-testid="hero-cta-book-demo"
          onClick={() => scrollTo("contact")}
          className="bg-[#00FF66] text-[#0A0A0A] font-cabinet font-black uppercase text-sm tracking-widest px-8 py-4 hover:bg-[#0A0A0A] hover:text-[#00FF66] transition-colors duration-200">
          
            BOOK A DEMO
          </button>
        </motion.div>

        {/* Stats row */}
        <motion.div
        data-testid="hero-stats"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.75 }}
        className="flex flex-wrap gap-8">
        
          {STATS.map((stat) =>
        <div key={stat.label} className="border-l-2 border-black/25 pl-4">
              <div className="font-cabinet text-3xl font-black text-[#0A0A0A]">
                {stat.value}
              </div>
              <div className="font-mono text-xs uppercase tracking-wider text-black/55 mt-0.5">
                {stat.label}
              </div>
            </div>
        )}
        </motion.div>
      </div>
    </div>
  </section>;


export default Hero;